import { useState } from 'react';
// import './MainPage.scss';
import cn from 'classnames';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import MainScreen from '../../components/MainScreen';
import PreFooter from '../../components/PreFooter';
import Back from './bg.jpg';
import Popup from '../../components/Popup';

const MainPage = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className='page'>
      <Header />
      <MainScreen
        background={Back}
        title='Interim Healthcare Leadership'
        text='Deploy experienced executives in days, not months. Maintain continuity while you find permanent leadership.'
        mainButtonText='Schedule Consultation'
        onMainClick={() => setIsPopupOpen(true)}
      />
      <div className='pointsSection'>
        <span className='blockTitle'>Why Choose Interim Leadership</span>
        <span className='blockText'>Critical leadership gaps compromise patient care and operations.</span>

        <div className='points'>
          <div className='pointItem'>
            <span className='pointItemTitle'>Immediate Availability</span>
            <span className='pointItemText'>
              Leaders deployed on-site within days, ensuring uninterrupted operations and patient care continuity during critical
              transition periods.
            </span>
            <span className='pointItemIcon'>1</span>
          </div>

          <div className='pointItem'>
            <span className='pointItemTitle'>Objective Assessment</span>
            <span className='pointItemText'>
              External perspective delivers unbiased organizational evaluation and strategic recommendations based on industry
              best practices.
            </span>
            <span className='pointItemIcon'>2</span>
          </div>

          <div className='pointItem'>
            <span className='pointItemTitle'>
              Proven <br />
              Expertise
            </span>
            <span className='pointItemText'>
              Seasoned healthcare executives with track records of rapid problem identification and effective solution
              implementation.
            </span>
            <span className='pointItemIcon'>3</span>
          </div>

          <div className='pointItem'>
            <span className='pointItemTitle'>Strategic Enhancement</span>
            <span className='pointItemText'>
              Implementation of proven methodologies and industry best practices that improve organizational performance.
            </span>
            <span className='pointItemIcon'>4</span>
          </div>

          <div className='pointItem'>
            <span className='pointItemTitle'>Transition Management</span>
            <span className='pointItemText'>
              Resolution of inherited challenges while establishing strong operational foundations for incoming permanent
              leadership.
            </span>
            <span className='pointItemIcon'>5</span>
          </div>
        </div>
      </div>

      <div className='tagsSection'>
        <span className='blockTitle'>Leadership Solutions</span>
        <span className='blockText'>Experienced professionals deliver value across critical healthcare functions.</span>
        <div className='tagsSectionList'>
          <span className='tagsSectionItem'>
            Emergency <br /> Coverage
          </span>
          <span className='tagsSectionItem'>
            Department
            <br /> Turnarounds
          </span>
          <span className='tagsSectionItem'>
            Survey <br /> Readiness
          </span>
          <span className='tagsSectionItem'>
            Confidential <br /> Transitions
          </span>
          <span className='tagsSectionItem'>
            Executive <br /> Mentoring
          </span>
          <span className='tagsSectionItem'>
            Organizational <br /> Assessment
          </span>
          <span className='tagsSectionItem'>
            Strategic <br /> Planning
          </span>
          <span className='tagsSectionItem'>
            Performance <br /> Improvement
          </span>
        </div>
      </div>

      <div className='quote'>
        <span className='quoteText'>
          "American Consultants is extremely quick in finding interim talent and professional in their interactions."
        </span>
        <span className='quoteAuthor'>Denise Clark</span>
        <span className='quoteAddress'>CNO, Taos, NM</span>
      </div>

      <div className='articleSection'>
        <span className='blockTitle'>Stability in Transition</span>
        <span className='blockText'>Interim leaders who keep your mission moving forward</span>
        <div className='articleContent'>
          <span className='articleText'>
            Leadership gaps can put pressure on operations, morale, and patient care — especially in critical times. Our interim
            leaders step in with confidence, clarity, and immediate impact. Whether you’re facing an unexpected departure, a
            planned transition, or a turnaround situation, we provide experienced healthcare executives who are ready to lead from
            day one. From CEOs and CMOs to department directors and operational leads, we deliver professionals with the expertise
            to maintain momentum and guide your team through uncertainty.
          </span>
          <span className='articleText'>
            Each interim placement is tailored to your unique goals, culture, and timeframe. We act fast, but never compromise on
            quality. Our nationwide network allows us to present seasoned leaders within days — not weeks — so your organization
            remains steady and focused. With a 90-day delivery promise and a satisfaction guarantee, you can rely on us to ensure
            leadership continuity while you plan for what’s next. Interim doesn’t mean temporary results — it means trusted
            leadership when it matters most.
          </span>
        </div>
      </div>

      {!!isPopupOpen && <Popup onClose={() => setIsPopupOpen(false)} />}

      <PreFooter
        title='Healthcare Professionals'
        text="Let's have a one-on-one conversation about your career goals and create opportunities that match your aspirations."
        mainButtonText='Schedule Consultation'
        onMainClick={() => setIsPopupOpen(true)}
      />
      <Footer />
    </div>
  );
};

export default MainPage;
